import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const unbindAlipay = async (params: object) => {
  return await POST({ url: Api.unbindAlipay, params, showError: false })
}
